<template>
    <div class="sustainable-component equality-report-gender-position-development">
        <!--<div class="bg-success mb-3 p-3 rounded">vue equality-report-gender-position-development</div>-->
        <div class="container-fluid p-0">
            <div class="row">
                <div class="col-12 col-md-6">
                    <v-select bg-color="white" variant="outlined" v-bind:label="$t('general.workorganisation_general_position')" :items="internalModel.JobPositions" v-model="selectedPosition" item-title="Name" item-value="JobPositionId"></v-select>
                    <div v-if="analysisCriterias1.length > 1">
                        <v-select bg-color="white" variant="outlined" v-bind:label="analysisCriteria1Name" :items="analysisCriterias1" v-model="analysisCriteria1" item-title="Name" item-value="Val"></v-select>
                    </div>

                    <div v-if="analysisCriterias2.length > 1">
                        <v-select bg-color="white" variant="outlined" v-bind:label="analysisCriteria2Name" :items="analysisCriterias2" v-model="analysisCriteria2" item-title="Name" item-value="Val"></v-select>
                    </div>
                </div>

                <div class="col-12 col-md-6">
                    <a href="javascript:void(0)" @click="PrintJobDevelopment">Visa kvinnors och mäns utveckling per befattning</a><br />
                    <a href="javascript:void(0)" @click="PrintJobDevelopmentByCompany">Visa kvinnors och mäns utveckling i alla befattningar</a>
                </div>
            </div>
        </div>
        <v-snackbar :timeout="2000" v-model="showSnackBar" color="success">
            {{snackbarMessage}}
        </v-snackbar>
        <v-snackbar :timeout="2000" v-model="showErrorMessageSnackBar" color="error">
            {{errorMessage}}
        </v-snackbar>
        <common-spinner v-bind:loading="loading > 0"></common-spinner>
    </div>
</template>


<script>

    import AdminService from "../../Services/AdminService";
    import CommonSpinner from '../../common/common-spinner.vue'

    export default {

        name: 'equality-report-gender-position-development',
        props: {
            model: Object,
            selectedJobPosition: String,
            disabled: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
        components: {
            CommonSpinner,
        },
        methods: {
            async PrintJobDevelopment() {
                if (this.selectedPosition == null) {
                   alert("Välj en befattning")
                   return;
                }
                this.newWindow = window.open('/equalityPrint/PrintDevelopmentByJobposition?jobPositionId=' + this.selectedPosition + this.getAnalysisParameters() , '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
            },
            getAnalysisParameters(){
                var ret = "";
                if(this.analysisCriteria1 != null)
                    ret = "&analysisCriteria1=" + this.analysisCriteria1;
                if(this.analysisCriteria2 != null)
                    ret += "&analysisCriteria2=" + this.analysisCriteria2;
                return ret;
            },
            async PrintJobDevelopmentByCompany() {
                this.newWindow = window.open('/equalityPrint/PrintDevelopmentByCompany?' + this.getAnalysisParameters(), '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
            },
            async getEmployeeAnalysisCriteria() {
                this.loading++;
                try {
                    var analysisCriterias = await AdminService.getAnalysisCriterias();
                    if (analysisCriterias.Criteria1.Active == true) {
                        this.analysisCriterias1 = analysisCriterias.Criteria1.ContentItems;
                        this.analysisCriteria1Name = analysisCriterias.Criteria1.Name;
                    }

                    if (analysisCriterias.Criteria2.Active == true) {
                        this.analysisCriterias2 = analysisCriterias.Criteria2.ContentItems;
                        this.analysisCriteria2Name = analysisCriterias.Criteria2.Name;
                    }
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            displaySnackBar(message) {
                this.snackbarMessage = message;
                this.showSnackBar = true;
            },
            displayErrorSnackBar(message) {
                this.errorMessage = message;
                this.showErrorMessageSnackBar = true;
            },
        },

        data() {
            return {
                selectedPosition: null,
                internalModel:{
                    JobPositions: [],
                    JobTaskSuggestions: [],
                },
                jobPositionTasks: [],
                jobPositionBlocks: [],
                jobPositionName: '',
                jobBlockName: '',
                jobBlockNumber: -1,
                enableRegulation: false,
                newWindow: {},
                analysisCriteria1: null,
                analysisCriterias1: [],
                analysisCriteria1Name: null,
                analysisCriteria2: null,
                analysisCriteria2Name: null,
                analysisCriterias2: [],
                loading: 0,
                showSnackBar: false,
                snackbarMessage: null,
                showErrorMessageSnackBar: false,
                errorMessage: null,
            };
        },
        watch: {
            selectedPosition: function (newVal) {
                this.$emit('positionSelected', newVal)
            },
        },
        mounted() {
            this.internalModel = this.model;
            this.selectedPosition = this.selectedJobPosition;
            this.getEmployeeAnalysisCriteria();
        },
        setup() {
            return { }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
